import Repository from "../../repository";

export default {
    Monitor: (payload) => Repository.post(`/api/SmartGasCustomer/Monitor`, payload),
    SetRestart: (payload) => Repository.post(`/api/SmartGasCustomer/SetRestart`, payload),
    SetRefresh: (payload) => Repository.post(`/api/SmartGasCustomer/SetRefresh`, payload),
    SetLock: (payload) => Repository.post(`/api/SmartGasCustomer/SetLock`, payload),
    SetGasUse: (payload) => Repository.post(`/api/SmartGasCustomer/SetGasUse`, payload),
    GetListNode: (payload) => Repository.post(`/api/SmartGasCustomer/GetListNode`, payload),
    EditNode: (payload) => Repository.post(`/api/SmartGasCustomer/EditNode`, payload),
    GetLevelDetector: (payload) => Repository.post(`/api/SmartGasCustomer/GetLevelDetector`, payload),
    AddInfo: (payload) => Repository.post(`/api/SmartGasCustomer/AddInfo`, payload),
    DelInfo: (payload) => Repository.post(`/api/SmartGasCustomer/DelInfo`, payload),
}
